/*
 * 版权声明
 * 上海万位数字技术有限公司（以下简称“本公司”）对其自行研究开发、编写编制的软件程序、代码等（以下简称“研发资料”）均受《中华人民共和国反不正当竞争法》、《中华人民共和国著作权法》、《中华人民共和国专利法》及适用之国际公约中有关著作权、专利权及/或其他财产所有权法律的保护，为本公司专属或持有。
 * 使用者将本公司专属或持有的研发资料用于商业、营利、广告性目的时，需事先征得本公司书面特别授权，并注明出处“上海万位数字技术有限公司”，并按照有关国际公约及中华人民共和国法律的有关规定，向本公司支付使用费。
 * 未经本公司事先明确的书面特别授权，任何单位或个人不得以任何形式、任何途径，通过任何渠道变更、篡改、发行、发布、散布、复制、重制、展示或利用研发资料全部或部分内容，否则以侵权论，依法追究法律责任。
 *
 * Copyright Notice
 * All the software programs and codes among others (hereinafter referred to as the R&D data) solely developed and written by Shanghai Wanway Digital Technology Co., Ltd. (hereinafter referred to as the Company) are protected by the Law of the People's Republic of China against Unfair Competition, Copyright Law of the People's Republic of China, Patent Law of the People's Republic of China and provisions on laws of copyrights, patent rights and/or other property ownership in international conventions that apply and exclusive to or owned by the Company.
 * While using the R&D data exclusive to or possessed by the Company for any commercial, marketing, or advertising purpose, users need ask for special authorization from the Company in writing beforehand, note the source "Shanghai Wanway Digital Technology Co., Ltd." and pay the Company royalties subject to relevant provisions in related international conventions and laws of the People's Republic of China.
 * With no prior and express written special authorization from the Company, any unit or individual shall not alter, tamper, issue, release, distribute, duplicate, remake, produce or use part or all of the R&D data in any form and any way, otherwise it shall be deemed as infringement and subject to legal penalties by law.
 */

/**
 * Created by smx on 2017/3/16.
 */
import React from 'react'
import moment from 'moment';
import {Radio} from 'antd';
const RadioGroup = Radio.Group,RadioButton = Radio.Button;
const dateFormatWithOutHMS = 'YYYY-MM-DD', dateFormat = 'YYYY-MM-DD HH:mm:ss';
class StatisticsDate extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isFreeAccount: localStorage.getItem('isFreeAccount')=='1',
            choosedValue: this.props.choosedValue || "",
        }
        this.yestaday = this.yestaday.bind(this);
        this.lastWeek = this.lastWeek.bind(this);
        this.thisMouth = this.thisMouth.bind(this);
        this.thisWeek = this.thisWeek.bind(this);
        this.lastmouth = this.lastmouth.bind(this);
        this.thisDay = this.thisDay.bind(this);
        this.updateDatePickerTime = this.updateDatePickerTime.bind(this)
    }
    componentDidUpdate(prevProps) {
        if (this.props.choosedValue !== prevProps.choosedValue) {
            this.setState({
                choosedValue:this.props.choosedValue
            })
        }
    }
    //今天
    thisDay() {
        let startTime = moment().hour(0).minute(0).second(0);
        let endTime = moment();
        this.props.changeTime(startTime, endTime);
    }

    //昨天
    yestaday() {
        let startTime = moment().subtract(1, 'day').hour(0).minute(0).second(0);
        let endTime = moment().subtract(1, 'day').hour(23).minute(59).second(59);
        this.props.changeTime(startTime, endTime);
    }

    //本周
    thisWeek() {
        // let startTime = moment().day(0).hour(0).minute(0).second(0);
        let startTime = moment().weekday(0).hour(0).minute(0).second(0);
        let endTime = moment();
        this.props.changeTime(startTime, endTime);
    }

    //上周
    lastWeek() {
        let weekOfDay = new Date().getDay() // 今天星期几
        // let startTime = moment().day(-7).startOf('day').hour(0).minute(0).second(0);
        let startTime = moment().subtract(weekOfDay + 7 - 1, 'days').hour(0).minute(0).second(0);
        let endTime = moment().subtract(weekOfDay , 'days').hour(23).minute(59).second(59);
        this.props.changeTime(startTime, endTime);
    }

    //本月
    thisMouth() {
        let startTime = moment().startOf('month').hour(0).minute(0).second(0);
        let endTime = moment();
        if (dateFormatWithOutHMS == this.props.dateFormat) {
            endTime = moment().subtract(0, 'day').hour(23).minute(59).second(59);
        }
        this.props.changeTime(startTime, endTime);

    }

    //上月
    lastmouth() {
        let startTime = moment().subtract(1, 'month').startOf('month').hour(0).minute(0).second(0);
        let endTime = moment().subtract(1, 'month').endOf('month').hour(23).minute(59).second(59);
        this.props.changeTime(startTime, endTime);
    }
    updateDatePickerTime(e){
        let type = e.target.value;
        switch (type){
            case "todady":this.thisDay();break;
            case "yestaday":this.yestaday();break;
            case "thisWeek":this.thisWeek();break;
            case "lastWeek":this.lastWeek();break;
            case "thisMouth":this.thisMouth();break;
            case "lastmouth":this.lastmouth();break;
            default:
                this.yestaday();

        }
        this.setState({
            choosedValue: type
        }, () => {
            if (this.props.onChoosedValueChange) {
                this.props.onChoosedValueChange(type);
            }
        });
    }
    render() {
        const {isFreeAccount,choosedValue} = this.state;
        return (
            <RadioGroup  onChange={this.updateDatePickerTime} value={choosedValue}>
                {this.props.isShowToday==false?'': <RadioButton className={"h30"} value={"todady"} >{Strings.today || "今天"}</RadioButton>}
                <RadioButton className={"h30"} value={"yestaday"} >{Strings.yesterday || "昨天"}</RadioButton>
                {this.props.isNotShowWeek?'': <RadioButton className={"h30"} value={"thisWeek"} >{Strings.thisWeek || "本周"}</RadioButton>}
                {this.props.isNotShowWeek?'':<RadioButton className={"h30"} value={"lastWeek"} >{Strings.lastWeek || "上周"}</RadioButton>}
                {this.props.lastmouth==false?'':<RadioButton className={"h30"} value={"thisMouth"} >{Strings.thisMouth || "本月"}</RadioButton>}
                {this.props.lastmouth==false || isFreeAccount?'':<RadioButton className={"h30"} value={"lastmouth"} >{Strings.lastMouth || "上月"}</RadioButton>}
            </RadioGroup>
        )
    }
}
export default StatisticsDate
